/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { color, pxToEm, replacePXinStringWithEM, centerAbsolutely, backgrounds } from 'utils/styles';
import { url } from 'utils/urls';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// OUT OF CONTENT STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
    uniquecontent: {
    	background: `${backgrounds.standout} !important`,
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 'inherit',
    	'& .uniquescreen':{
            padding: replacePXinStringWithEM('0 20px'),
            // bounding box to center all different logo types within
            '& .partnermessage': {
                width: pxToEm(180),
                height: pxToEm(180),
                extend: centerAbsolutely,
                // override partner logo base styles to match new OOC design
                '& .logo': {
                    '&.partner': {
                        backgroundPosition: '50% !important',
                        width: '100% !important',
                        height: '100% !important',
                        // animation
                        opacity: '0',
                        animationName: 'fadeInDown',
                        animationDuration: '.4s',
                        animationDelay: '.45s',
                        animationFillMode: 'forwards'
                    }
                }
            },
            // general message if we don't have a partner logo uploaded
            '& .fallbackmessage': {
                '& .graphic.ooc': {
                    backgroundColor: 'transparent',
                    backgroundImage: `url(${url.image.app}/graphic-ooc-opt.png)`,
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: '50%',
                    backgroundSize: 'contain',
                    width: pxToEm(103),
                    height: pxToEm(113),
                    margin: replacePXinStringWithEM('0 auto 30px'),
                    // animation
                    opacity: '0',
                    animationName: 'rotateIn',
                    animationDuration: '.3s',
                    animationDelay: '.2s',
                    animationFillMode: 'forwards'
                },
                '& .title': {
                    // animation
                    opacity: '0',
                    animationName: 'fadeInUp',
                    animationDuration: '.3s',
                    animationDelay: '.3s',
                    animationFillMode: 'forwards'
                },
                '& .bodycopy': {
                    // animation
                    opacity: '0',
                    animationName: 'fadeInUp',
                    animationDuration: '.4s',
                    animationDelay: '.4s',
                    animationFillMode: 'forwards'
                }
            }
        },
        '& .footer': {
            textAlign: 'center',
            width: '100%',
            position: 'absolute',
            bottom: pxToEm(15),
            left: '0'
        }
    }
};
